import { useFormContext } from "react-hook-form";

const WitnessStatementSummaryFields = () => {
  const { register } = useFormContext();
  return (
    <>
      <div className="row mx-0 p-l-5  align-items-center custom-margin-bottom">
        <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
          Concerning:
        </span>
        <div className="d-flex-1 p-l-5 p-r-5 m-t-5">
          <textarea
            style={{ height: "25px", resize: "none" }}
            className="form-control rounded-0 p-l-5 p-0"
            placeholder="Enter Concerning"
            {...register("statement_concerning")}
          />
        </div>
      </div>
      <div className="row mx-0  p-l-5 align-items-center custom-margin-bottom">
        <span className="d-inline-block white-space-nowrapping text-grey align-self-start m-r-5 defendant-input-label">
          Statement Summary:
        </span>
        <div className="d-flex-1 p-l-5 p-r-5">
          <textarea
            style={{ height: "150px", resize: "none" }}
            className="form-control rounded-0 p-l-5 p-0"
            placeholder="Enter Summary"
            {...register("statement_summary")}
          />
        </div>
      </div>
    </>
  );
};

export default WitnessStatementSummaryFields;
